import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent{
    @Input() dataSource: any[] = [];
    @Input() displayedColumns: string[] = [];
    @Input() translateColumns: string[] = [];
    @Input() numberColumns: string[] = [];
}
